import { HostContext } from '../../embed-script/HostContext';
import { BackendServiceUrl, BaseService } from './BaseService';

export class DictationService extends BaseService {
    constructor(accessToken: string, baseServiceUrl: string = BackendServiceUrl) {
        super(accessToken, baseServiceUrl);
    }

    /** What was said in the clip; empty when nothing was heard. An abort stops the upload, and rejects. */
    public async transcribeAsync(wav: Blob, hostContext?: HostContext, signal?: AbortSignal): Promise<string> {
        const form = new FormData();
        form.append('audio', wav, 'dictation.wav');
        const result = await this.getResponseAsync<{ text?: unknown }>({
            commandPath: 'voice/dictation',
            method: 'POST',
            body: form,
            hostContext,
            signal,
            // Otherwise a 429 resolves as {} and reads as "nothing heard"; BaseService has already shown its warning.
            throwOnRateLimit: true,
        });
        return typeof result.text === 'string' ? result.text : '';
    }
}
